var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.verifyPermission())?_vm._t("default"):(!_vm.verifyPermission())?_vm._t("not"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }